(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initStickyHeader();
    initDropdown();
    initFaq();
    initLightTabs();
    initFeaturedLightPicker();
    initProcessTimeline();
    initStepTimeline();
    initExternalLinks();
    initTestimonialSlider();
    initCartDrawer();
    initNewsletterForms();
  });

  function initStickyHeader() {
    var header = document.querySelector('.header');
    if (!header) return;

    var announce = document.querySelector('.announce');
    var threshold = announce ? announce.offsetHeight : 30;

    var spacer = document.createElement('div');
    spacer.className = 'header-spacer';
    spacer.style.display = 'none';
    header.parentNode.insertBefore(spacer, header.nextSibling);

    function pin() {
      if (header.classList.contains('header-pinned')) return;
      spacer.style.height = header.offsetHeight + 'px';
      spacer.style.display = 'block';
      header.classList.add('header-pinned');
      header.style.transform = 'translateY(-100%)';
      header.getBoundingClientRect();
      requestAnimationFrame(function () {
        header.style.transform = 'translateY(0)';
      });
    }

    function unpin() {
      if (!header.classList.contains('header-pinned')) return;
      header.classList.remove('header-pinned');
      header.style.transform = '';
      spacer.style.display = 'none';
    }

    function updateHeaderBottom() {
      document.documentElement.style.setProperty('--header-bottom', header.getBoundingClientRect().bottom + 'px');
    }

    function onScroll() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > threshold) {
        pin();
        header.classList.add('is-scrolled');
      } else {
        unpin();
        header.classList.remove('is-scrolled');
      }
      updateHeaderBottom();
    }

    document.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateHeaderBottom);
    onScroll();
  }



  function initDropdown() {
    var shopBtn = document.getElementById('shopBtn');
    var mobileBtn = document.getElementById('mobileMenu');
    var dropdown = document.getElementById('dropdown');
    if (!dropdown) return;

    var menuVideos = dropdown.querySelectorAll('video');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setOpen(open) {
      dropdown.classList.toggle('open', open);
      // Collection videos only load and play while the menu is open.
      menuVideos.forEach(function (v) {
        if (open && !reduceMotion) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
      document.body.classList.toggle('menu-open', open);
      if (mobileBtn) {
        mobileBtn.classList.toggle('is-open', open);
        mobileBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var label = mobileBtn.querySelector('.mobile-menu-label');
        if (label) label.textContent = open ? 'Close' : 'Menu';
      }
    }

    if (shopBtn) {
      shopBtn.addEventListener('click', function () {
        setOpen(!dropdown.classList.contains('open'));
      });
    }
    if (mobileBtn) {
      mobileBtn.addEventListener('click', function () {
        setOpen(!dropdown.classList.contains('open'));
      });
    }
    document.addEventListener('click', function (e) {
      if (!dropdown.classList.contains('open')) return;
      if (dropdown.contains(e.target) || e.target === shopBtn || (mobileBtn && mobileBtn.contains(e.target))) return;
      setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  function initFaq() {
    document.querySelectorAll('.faq button').forEach(function (b) {
      b.addEventListener('click', function () {
        var a = b.nextElementSibling;
        a.classList.toggle('open');
        var span = b.querySelector('span');
        if (span) span.textContent = a.classList.contains('open') ? '−' : '+';
      });
    });
    document.querySelectorAll('.accordion button').forEach(function (b) {
      b.addEventListener('click', function () {
        var panel = b.nextElementSibling;
        var isOpen = panel.classList.toggle('open');
        b.classList.toggle('is-open', isOpen);
        b.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        var span = b.querySelector('span');
        if (span) span.textContent = isOpen ? '−' : '+';
      });
    });
  }

  function initLightTabs() {
    var tabs = document.querySelectorAll('.light-tab');
    var lightVisual = document.getElementById('lightVisual');
    var lightQuote = document.getElementById('lightQuote');
    if (!tabs.length || !lightVisual) return;
    var placeholder = lightVisual.querySelector('.placeholder-frame span');
    var placeholderWrap = lightVisual.querySelector('.visual-placeholder');
    var visualImg = document.getElementById('lightVisualImg');
    var orbit = lightVisual.querySelector('.orbit');
    if (orbit && visualImg && visualImg.style.display !== 'none') orbit.style.display = 'none';
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        lightVisual.classList.add('changed');
        setTimeout(function () {
          var imageUrl = tab.dataset.visualImage;
          if (imageUrl && visualImg) {
            visualImg.src = imageUrl;
            visualImg.alt = tab.dataset.visualLabel ? tab.dataset.visualLabel.replace(/<br>/g, ' ') : '';
            visualImg.style.display = 'block';
            if (placeholderWrap) placeholderWrap.style.display = 'none';
            if (orbit) orbit.style.display = 'none';
          } else {
            if (visualImg) visualImg.style.display = 'none';
            if (placeholderWrap) placeholderWrap.style.display = 'flex';
            if (placeholder) placeholder.innerHTML = tab.dataset.visualLabel || '';
            if (orbit) orbit.style.display = '';
          }
          if (lightQuote) lightQuote.textContent = tab.dataset.quote || '';
          lightVisual.classList.remove('changed');
        }, 160);
      });
    });
  }

  function initFeaturedLightPicker() {
    var picker = document.getElementById('featuredLightPicker');
    if (!picker) return;
    var metalPicker = document.getElementById('featuredMetalPicker');
    var lightButtons = picker.querySelectorAll('.swatch');
    var metalButtons = metalPicker ? metalPicker.querySelectorAll('.metal-chip') : [];
    var photos = document.querySelectorAll('.js-light-photo');
    var cards = [];
    photos.forEach(function (img) {
      var card = img.closest('.product-card');
      var map = {};
      (img.dataset.imgs || '').split('|').forEach(function (entry) {
        var i = entry.indexOf(' ');
        if (i > 0) map[entry.slice(0, i)] = entry.slice(i + 1);
      });
      img._map = map;
      var hover = card ? card.querySelector('.js-hover-photo') : null;
      if (hover) {
        var hoverMap = {};
        (hover.dataset.imgs || '').split('|').forEach(function (entry) {
          var i = entry.indexOf(' ');
          if (i > 0) hoverMap[entry.slice(0, i)] = entry.slice(i + 1);
        });
        hover._map = hoverMap;
        img._hover = hover;
      }
      if (card) { card.dataset.baseHref = card.getAttribute('href'); cards.push(card); }
    });
    var light = 'white';
    var metal = metalButtons.length ? metalButtons[0].dataset.metal : 'white-gold';
    var lightTouched = false;
    var metalTouched = false;

    function update() {
      photos.forEach(function (img) {
        var src = img._map[metal + '-' + light];
        if (src) img.src = src;
        if (img._hover) {
          var hoverSrc = img._hover._map[metal + '-' + light];
          if (hoverSrc) img._hover.src = hoverSrc;
          img._hover.hidden = !hoverSrc;
        }
      });
      cards.forEach(function (card) {
        var params = [];
        if (lightTouched) params.push('light=' + encodeURIComponent(light));
        if (metalTouched) params.push('metal=' + encodeURIComponent(metal));
        card.setAttribute('href', card.dataset.baseHref + (params.length ? '?' + params.join('&') : ''));
      });
    }

    lightButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        lightButtons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        light = btn.dataset.light.toLowerCase();
        lightTouched = true;
        update();
      });
    });
    metalButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        metalButtons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        metal = btn.dataset.metal;
        metalTouched = true;
        update();
      });
    });
  }

  function initProcessTimeline() {
    var row = document.querySelector('.process-row');
    if (!row) return;
    var items = Array.prototype.slice.call(row.querySelectorAll('.process-item'));
    if (items.length < 2) return;
    var current = -1;
    var timer = null;
    var paused = false;
    var visible = false;

    function setActive(i) {
      current = i;
      items.forEach(function (item, idx) {
        item.classList.toggle('active', idx === i);
        item.classList.toggle('done', idx < i);
      });
      row.style.setProperty('--p', String(i / (items.length - 1)));
    }

    function tick() {
      if (paused || !visible) return;
      setActive((current + 1) % items.length);
    }

    function start() {
      if (!timer) timer = setInterval(tick, 3200);
    }

    items.forEach(function (item, idx) {
      item.setAttribute('tabindex', '0');
      item.addEventListener('mouseenter', function () { paused = true; setActive(idx); });
      item.addEventListener('mouseleave', function () { paused = false; });
      item.addEventListener('click', function () { setActive(idx); });
      item.addEventListener('focus', function () { setActive(idx); });
    });

    setActive(0);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start();
      }, { threshold: 0.35 }).observe(row);
    } else {
      visible = true;
      start();
    }
  }

  // Links to other websites (Instagram, press, article sources) open in a new tab.
  function initExternalLinks() {
    var host = window.location.hostname;
    document.querySelectorAll('a[href]').forEach(function (a) {
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.href); } catch (e) { return; }
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
      if (url.hostname === host || /\.myshopify\.com$/.test(url.hostname)) return;
      a.target = '_blank';
      var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      a.setAttribute('rel', rel.join(' '));
    });
  }

  function initStepTimeline() {
    var rows = document.querySelectorAll('[data-step-timeline]');
    Array.prototype.forEach.call(rows, function (row) {
      var items = Array.prototype.slice.call(row.querySelectorAll('.step'));
      if (items.length < 2) return;
      var interval = 3600;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = -1;
      var timer = null;
      var paused = false;
      var visible = false;

      row.classList.add('is-interactive');
      row.style.setProperty('--step-interval', interval + 'ms');

      function setActive(i) {
        current = i;
        items.forEach(function (item, idx) {
          item.classList.toggle('active', idx === i);
          item.classList.toggle('done', idx < i);
          item.setAttribute('aria-current', idx === i ? 'step' : 'false');
        });
      }

      function restart() {
        clearInterval(timer);
        timer = null;
        if (!reduceMotion && visible && !paused) timer = setInterval(tick, interval);
      }

      function tick() {
        if (paused || !visible) return;
        setActive((current + 1) % items.length);
      }

      items.forEach(function (item, idx) {
        item.setAttribute('tabindex', '0');
        item.addEventListener('mouseenter', function () { paused = true; row.classList.add('is-paused'); setActive(idx); restart(); });
        item.addEventListener('mouseleave', function () { paused = false; row.classList.remove('is-paused'); restart(); });
        item.addEventListener('click', function () { setActive(idx); restart(); });
        item.addEventListener('focus', function () { setActive(idx); restart(); });
        item.addEventListener('keydown', function (e) {
          var next = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? idx + 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? idx - 1 : null;
          if (next === null || next < 0 || next >= items.length) return;
          e.preventDefault();
          items[next].focus();
        });
      });

      setActive(0);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible && !row.classList.contains('in-view')) {
            row.classList.add('in-view');
            setTimeout(function () { row.classList.add('revealed'); }, 1400);
          }
          restart();
        }, { threshold: 0.3 }).observe(row);
      } else {
        visible = true;
        row.classList.add('in-view', 'revealed');
        restart();
      }
    });
  }

  function initTestimonialSlider() {
    var cards = Array.from(document.querySelectorAll('.testimonial-card'));
    if (!cards.length) return;
    var index = 0;
    function render() {
      if (window.innerWidth > 1000) {
        cards.forEach(function (c) { c.style.display = 'flex'; });
        return;
      }
      cards.forEach(function (c, i) { c.style.display = i === index ? 'flex' : 'none'; });
    }
    var prev = document.getElementById('testimonialPrev');
    var next = document.getElementById('testimonialNext');
    if (prev) prev.addEventListener('click', function () { index = (index - 1 + cards.length) % cards.length; render(); });
    if (next) next.addEventListener('click', function () { index = (index + 1) % cards.length; render(); });
    window.addEventListener('resize', render);
    render();
  }

  function initNewsletterForms() {
    document.querySelectorAll('.newsletter-form').forEach(function (form) {
      if (form.tagName !== 'FORM') return;
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button');
        if (btn) btn.textContent = 'Joining...';
      });
    });
  }

  // ---- Cart drawer (real Shopify Cart AJAX API) ----

  var drawer, overlay;

  function initCartDrawer() {
    drawer = document.getElementById('drawer');
    overlay = document.getElementById('overlay');
    var bagBtn = document.getElementById('bagBtn');
    var drawerClose = document.getElementById('drawerClose');

    if (bagBtn) bagBtn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ev-add-to-cart]');
      if (!form) return;
      e.preventDefault();
      submitAddToCart(form);
    });

    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-ev-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        changeCartLine(removeBtn.dataset.evCartRemove, 0);
      }
    });

    refreshCart();
  }

  window.evOpenCartDrawer = openDrawer;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('show');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('show');
  }

  function submitAddToCart(form) {
    var formData = new FormData(form);
    var btn = form.querySelector('[type="submit"]');
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          throw new Error(data.description || 'Could not add to bag');
        }
        return refreshCart();
      })
      .then(function () {
        openDrawer();
      })
      .catch(function (err) {
        console.error('[evelina] add to cart failed', err);
        if (btn) btn.textContent = 'Could not add — try again';
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          if (btn.textContent === 'Adding...') btn.textContent = originalText;
        }
      });
  }

  function changeCartLine(key, quantity) {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (res) { return res.json(); })
      .then(renderCart)
      .catch(function (err) { console.error('[evelina] cart update failed', err); });
  }

  function refreshCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) { return res.json(); })
      .then(renderCart);
  }

  function renderCart(cart) {
    var countEl = document.getElementById('count');
    if (countEl) countEl.textContent = cart.item_count;

    var body = document.getElementById('cartBody');
    var footer = document.getElementById('drawerFoot');
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<p>Your bag is currently empty.</p>';
      if (footer) footer.style.display = 'none';
      return;
    }
    if (footer) footer.style.display = '';

    body.innerHTML = cart.items
      .map(function (item) {
        var optionsText = (item.options_with_values || [])
          .map(function (o) { return o.name + ': ' + o.value; })
          .join(' · ');
        var img = item.image
          ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '">'
          : '<div class="visual-placeholder"><div class="placeholder-frame"><span>Product Visual</span></div></div>';
        return (
          '<div class="cart-item">' +
          img +
          '<div><strong>' + escapeHtml(item.product_title) + '</strong>' +
          '<small>' + escapeHtml(optionsText) + '<br>' + formatMoney(item.final_line_price) + '</small>' +
          '<button class="back" data-ev-cart-remove="' + item.key + '" style="margin-top:8px">Remove</button></div>' +
          '<div></div>' +
          '</div>'
        );
      })
      .join('');

    var totalEl = document.getElementById('total');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + parts[0] + ',' + parts[1];
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }
})();
